import { assign, createMachine } from 'xstate';

import { trackCTATapped } from 'utils/segment/trackingEvents';

const getToken = assign(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (context: MContext, { type, ...event }: any) => ({
    token: event.token,
    publicId: event.publicId,
  })
);

const getClaimInfo = assign({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  claimInfo: (context: MContext, { type, ...event }) => ({
    ...context.claimInfo,
    ...event,
  }),
});

const getError = assign({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  error: (_, event: { error_id; error_header; error_body }) => ({
    id: event.error_id,
    header: event.error_header,
    body: event.error_body,
  }),
});

type MContext = {
  token: string;
  publicId: string;
  claimInfo: Record<string, any>;
  error?: ErrorBody;
};

type ErrorBody = {
  id: string;
  header: string;
  body: string;
};

export const navigationMachine = createMachine<MContext>(
  {
    id: 'navigation',
    initial: 'loading',
    context: {
      token: undefined,
      publicId: undefined,
      claimInfo: {},
      error: undefined,
    },
    states: {
      loading: {
        on: {
          TOKEN: {
            actions: ['getToken'],
          },
          RETURN_USER_LANDING: {
            target: 'returnUserLanding',
          },
          NEXT: {
            target: 'landing',
          },
        },
      },
      landing: {
        on: {
          RETURN_USER_LANDING: {
            target: 'returnUserLanding',
          },
          NEXT: {
            target: 'claimInfo',
            actions: [
              context => {
                trackCTATapped(
                  'Pay Anyone',
                  'Claim for free',
                  'Landing Page',
                  'pay_anyone_landing_next_button',
                  context.publicId
                );
              },
            ],
          },
        },
      },
      returnUserLanding: {
        on: {
          NEXT: {
            target: 'confirmation',
            actions: [
              context => {
                trackCTATapped(
                  'Pay Anyone',
                  'Return User Transfer',
                  'Return User Landing Page',
                  'pay_anyone_reuse_debit_card_transfer_button',
                  context.publicId
                );
              },
            ],
          },
          CHANGE_CARD: {
            target: 'claimInfo',
          },
          ERROR_PAGE: {
            target: 'error',
            actions: ['getError'],
          },
        },
      },
      claimInfo: {
        on: {
          NEXT: {
            target: 'confirmation',
            actions: ['getClaimInfo'],
          },
          //TODO: Temporal to enable testing for RFA confirmation. Will remove in https://chime.atlassian.net/browse/PAGE-438
          NEXT_RECEIVE: {
            target: 'receiveFromAnyoneConfirmation',
          },
          ERROR_PAGE: {
            target: 'error',
            actions: ['getError'],
          },
        },
      },
      error: {
        type: 'final',
      },
      confirmation: {
        type: 'final',
      },
      receiveFromAnyoneConfirmation: {
        type: 'final',
      },
    },
  },
  {
    actions: { getToken, getClaimInfo, getError },
  }
);
